import { supabase } from './supabase.js';

/**
 * Attribution d'un numéro neuf à une caisse dont l'étiquette est illisible,
 * effacée ou arrachée.
 *
 * Plutôt que de compter une caisse « sans numéro » — qui sort alors du dépôt
 * sans exister, c'est le trou qu'on vient de fermer — l'app donne un numéro
 * jamais utilisé. Le magasinier l'écrit au marqueur sur la caisse : elle
 * redevient suivie, et le parc se réétiquette au fil des jours.
 */

// Les numéros connus vont jusqu'à ~11 200. On prend toujours au-dessus du plus
// grand connu : aucun risque de tomber sur une caisse existante non scannée.
export async function prochainNumeroLibre() {
  const { data, error } = await supabase
    .from('elixir_prep_caisse_stock')
    .select('code')
    .order('code', { ascending: false })
    .limit(2000);
  if (error) throw error;
  let max = 0;
  (data || []).forEach(({ code }) => {
    const m = String(code || '').match(/^C0*(\d+)/);
    if (m) { const n = parseInt(m[1], 10); if (n > max) max = n; }
  });
  return 'C' + (max + 1);
}

/**
 * Demande confirmation au magasinier et renvoie le numéro à utiliser,
 * ou null s'il renonce.
 */
export async function attribuerNumero() {
  const code = await prochainNumeroLibre();
  const ok = confirm(
    'ÉTIQUETTE ILLISIBLE\n\n'
    + 'Nouveau numéro attribué à cette caisse :\n\n'
    + '          ' + code + '\n\n'
    + 'Écris-le au marqueur sur la caisse, puis valide.\n'
    + 'La caisse sera suivie normalement à partir de maintenant.'
  );
  return ok ? code : null;
}
